module.exports = __webpack_public_path__ + "img/xr_fov.270adf9b.jpg";